import * as React from 'react';
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { ToolInvocation } from '../types';

import { ToolCallProps } from './DefaultToolCall';
import { ToolStatus } from './ToolStatus';
import * as UserActions from './UserActions';

export const SaveStudyToolCall: React.FC<ToolCallProps> = ({ toolInvocation, message }) => {
  const navigate = useNavigate();

  // Extract study_id from successful tool invocation
  const studyId =
    toolInvocation.state === 'result' &&
    toolInvocation.result &&
    typeof toolInvocation.result === 'object' &&
    'study_id' in toolInvocation.result
      ? (toolInvocation.result as any).study_id
      : null;

  // Auto-redirect when study creation succeeds
  useEffect(() => {
    if (studyId && toolInvocation.state === 'result') {
      const redirectTimer = setTimeout(() => {
        navigate(`/studies/${studyId}/plan`);
      }, 1500); // Wait 1.5 seconds to show the "Redirecting..." message

      return () => clearTimeout(redirectTimer);
    }
  }, [studyId, toolInvocation.state, navigate]);

  return (
    <div className='mt-2'>
      <UserActions.CreatedStudy message={message} />
      <ToolStatus
        state={toolInvocation.state}
        doneText='Redirecting you to your study…'
        executingText='Creating your study…'
      />
    </div>
  );
};
